export enum VotingSchemaType {
    Text = 0,
    Choices = 1,
    YasOrNo = 2
}
